import { SanityContentImage, SanityContentVideo } from "@modules/common/cms/sanityType"
import { PortableText, PortableTextProps } from "@portabletext/react"
import { useEffect, useState } from "react"
import { YouTubeVideo } from "@modules/utils/components/youTubeVideo"
import { useTheme } from "styled-components"

export const HUPortableText = ({ value }: PortableTextProps) => {
  const theme = useTheme()

  const portableTextComponents = {
    list: {
      bullet: ({ children }: any) => <ul className="mb-4">{children}</ul>,
    },

    listItem: {
      bullet: ({ children }: any) => <li className="mb-2">{children}</li>,
      checkmarks: ({ children }: any) => <ol className="mb-4">{children}</ol>,
    },
    marks: {
      link: ({ value, children }: any) => {
        return (
          <a className="underline cursor-pointer"href={value?.href} target={"_blank"} rel="noreferrer" style={{color:theme.textLink}}>
            {children}
          </a>
        )
      },
    },
    types: {
      content_image: ContentImage,
      content_video: ContentVideo,
    },
  }


  return (
    <PortableText
      value={value}
      components={portableTextComponents}
    />
  )
}

const ContentImage = (imageNode: { value: SanityContentImage }) => {
  const image = imageNode.value
  const [maxImageWidth, setMaxImageWidth] = useState(100)

  useEffect(() => {
    const splittedImgUrl = image.uri.split("-")
    const dimensions = splittedImgUrl[splittedImgUrl.length - 1]

    if (dimensions.split("x").length === 2) {
      setMaxImageWidth(parseInt(dimensions.split("x")[0]))
    }
  }, [image])

  return (
    <img
      src={image.uri}
      alt={image.alt_text}
      className="w-full h-full mx-auto my-4 block"
      style={{
        borderRadius: 33,
        maxWidth: maxImageWidth,
      }}
    />
  )
}


const ContentVideo = (videoNode: { value: SanityContentVideo }) => {
  const articleVideo = videoNode.value

  return (
    <div className="my-4">
      <YouTubeVideo link={articleVideo.uri} width={480} height={270} />
    </div>
  )
}

